import React from 'react';
import { styled, css } from '@mui/material/styles';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { Typography } from '@mui/material';
import { useTranslation } from '@/src/i18n';
import { getPictureSource } from '../../utils/card';
import Avatar from '../../atoms/Avatar/Avatar';
import { getCardFullName } from '../../utils';
import SharedData from '@/components/organisms/DocumentCard/SharedData';

interface Props {
  card: CardHcd;
  handleChooseItem?: () => void;
  documentId?: string;
  withCheckbox?: boolean;
  CheckboxProps?: object;
}

const FullName = styled('span')(
  ({ theme }) => css`
    font-weight: 500;
    &:hover {
      color: ${theme.palette.text.primary};
    }
  `,
);

const Practitioner = styled('label')(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 55px 1fr auto;
    grid-column-gap: ${theme.spacing(2)};
    align-items: center;
    background-color: rgba(0, 0, 0, 0.12);
    margin-bottom: ${theme.spacing(2)};
    padding: ${theme.spacing(2)};
    border-radius: 4px;
    cursor: pointer !important;
  `,
);

const MainData = styled('span')`
  > span {
    display: block;
  }
`;

// TODO(nampnq): import form PractitionerSelect make the import cycle, fix it
const NO_PRAT_PREFER = 'NO_PRAT_PREFER';

const PractitionerItem = ({
  card,
  handleChooseItem,
  documentId,
  withCheckbox,
  ...props
}: Props) => {
  const { t } = useTranslation();
  const fullName = getCardFullName(t, card);

  return (
    <div onClick={handleChooseItem} data-testid="practitioner-card">
      <Practitioner
        htmlFor={card.id}
        className="popup-select--item with-avatar with-checkbox"
      >
        <Avatar
          source={
            card?.professional?.practitionerId === NO_PRAT_PREFER
              ? '/static/images/no-choice.svg'
              : getPictureSource(card)
          }
          size="small"
          type={card?.type}
        />

        <MainData>
          <FullName>{fullName}</FullName>
          <span>{card?.professional?.speciality?.name}</span>
          {withCheckbox && card?.type === 'PRACTITIONER' && (
            <Typography color="text.medium" variant="caption">
              {card?.center?.name}
            </Typography>
          )}
        </MainData>

        {withCheckbox && (
          <SharedData card={card} documentId={documentId} {...props} />
        )}
      </Practitioner>
    </div>
  );
};

export default PractitionerItem;
